<template>
  <main class="item-edit">
    <div class="overlay"></div>
    <div class="content">
      <div class="">
  			<div class="card-header bg-1 border-bottom-0 d-flex">
  				<div>
  					<h4 v-if="item.length > 0" class="card-title light">Editing Item<span v-if="item.length > 1">s</span></h4>
            <h4 v-else class="card-title light">New Item</h4>
  					<p class="card-subtitle color-2 mb-0">
              <span v-if="item.length == 1">{{item[0].sku}}</span>
              <span v-if="item.length > 1">{{item.map(i => i.sku).join(", ")}}</span>
            </p>
  				</div>
  				<div class="card-options ml-auto">
            <div class="input-group  btn-group">
              <button v-on:click.prevent="save" class="btn btn-primary">Save</button>
              <router-link
                :to="{ path: `/items/data`}"
                tag="button"
                class="btn btn-warning">
                Cancel
              </router-link>
							<button v-if="Data.featureEnabled('create',Data) && item.length > 0" v-on:click.prevent="duplicate" class="btn btn-secondary">Duplicate</button>
              <button v-if="Data.featureEnabled('delete',Data) && item.length > 0" v-on:click.prevent="remove" class="btn btn-danger">Delete</button>
            </div>
  				</div>
  			</div>
  			<div class="card-body">
  				<div class="row">
  					<div v-for="group in fieldmap" class="col">
              <div v-for="field in group">
                <Category
                  v-if="field.type == 'tree'"
                  view="full"
                  v-bind:item="item"
                  v-bind:field="field"
                  @saveTrigger="saveCollect"
                   />
                <Select
                   v-else-if="field.type == 'select'"
                   view="full"
                   v-bind:item="item"
                   v-bind:field="field"
                   @saveTrigger="saveCollect"
                    />
                <ImageInput
                   v-else-if="field.type == 'image'"
                   view="full"
                   v-bind:item="item"
                   v-bind:field="field"
                   @saveTrigger="saveCollect"
                    />
                <SwitchInput
                  v-else-if="field.type == 'switch'"
                  view="full"
                  v-bind:item="item"
                  v-bind:field="field"
                  @saveTrigger="saveCollect"
                   />
                <DynamicInput
                  v-else
                  view="full"
                  v-bind:item="item"
                  v-bind:field="field"
                  @saveTrigger="saveCollect"
                  />

              </div>
  					</div>
  				</div>
          <div class="row pull-right my-3">
            <div class="col-12 input-group  btn-group">
              <button v-on:click.prevent="save" class="btn btn-primary">Save</button>
              <router-link
                :to="{ path: `/items/data`}"
                tag="button"
                class="btn btn-warning">
                Cancel
              </router-link>
							<button v-if="Data.featureEnabled('create',Data) && item.length > 0" v-on:click.prevent="duplicate" class="btn btn-secondary">Duplicate</button>
              <button v-if="Data.featureEnabled('delete',Data) && item.length > 0" v-on:click.prevent="remove" class="btn btn-danger">Delete</button>
            </div>
          </div>
  			</div>
  		</div>
    </div>
  </main>
</template>

<script>
import Data from '../../main';
import DynamicInput from './input.vue';
import Category from './category.vue';
import Select from './select.vue';
import SwitchInput from './switch.vue';
import ImageInput from './image.vue';
import { global_emits } from '../../main';

export default {
	name: 'Edit',
	components: {DynamicInput, Category, SwitchInput, ImageInput, Select},
	props: {
		fields: Array,
	},
	data: function() {
		return {
			//  fields: Data.item_fields,
			per_col: 0,
			item: [],
			fieldmap: [],
      //collection to save in db
			toSave: {},
      // collection to update in view
      toUpdate:[]
		};
	},
	computed: {
		Data() {
			return Data;
		},
	}	,
	methods: {
		saveCollect: function(e) {
			this.toSave[e.name] = e.value;
      this.toUpdate.push(e);
		},
		save: function(e) {
			if ( Object.entries(this.toSave).length < 1 ) {
				return this.$notify({
					group: 'main',
					title: 'No changes.',
					text: 'There is nothing to save. Images getting saved automatically.',
					type: 'warn',
				});
			}


			// update
			if ( this.$route.params.ids != 'new' && this.$route.params.ids !== undefined) {
				this.$Progress.start();
				this.$axios.put(`/item`, {
					batch: this.$route.params.ids.split(','),
					update: this.toSave,
				})
					.then((response) => {
						this.$notify({
							group: 'main',
							title: 'Done.',
							text: 'The item(s) has been updated.',
							type: 'success',
						});
            global_emits.$emit('item_updated', {data:response.data.item, ids: this.$route.params.ids });
            this.$router.push({path: '/items'});

					})
					.catch((error) => {
						this.$notify({
							group: 'main',
							title: 'Something went wrong.',
							text: 'Please try again.',
							type: 'warn',
						});
					})
					.finally(()=>{
						this.$Progress.finish();
					});
			}
			// create
			else {
				if ( this.toSave.title === undefined || this.toSave.title === '' ) {
					return this.$notify({
						group: 'main',
						title: 'Please set item title.',
						text: 'We cannot save items without title.',
						type: 'warn',
					});
				}


				this.$Progress.start();
				this.$axios.post(`/item`, this.toSave)
					.then((response) => {
						this.$notify({
							group: 'main',
							title: 'Done.',
							text: 'The item has been added.',
							type: 'success',
						});
            global_emits.$emit('item_created', { item:response.data.item });
						this.$router.push({path: '/items'});
					})
					.catch((error) => {
						this.$notify({
							group: 'main',
							title: 'Something went wrong.',
							text: 'Please try again.',
							type: 'warn',
						});
					})
					.finally(()=>{
						this.$Progress.finish();
					});
			}
		},

		duplicate: function() {
			this.$Progress.start();
			this.$axios.post(`/item/duplicate/${this.$route.params.ids}`)
				.then((response) => {
					this.$notify({
						group: 'main',
						title: 'Done.',
						text: 'The item has been duplciated.',
						type: 'success',
					});
					global_emits.$emit('item_created', { item:response.data.item });
					this.$router.push({path: '/items'});
				})
				.catch((error) => {
					this.$notify({
						group: 'main',
						title: 'Something went wrong.',
						text: 'Please try again.',
						type: 'warn',
					});
				})
				.finally(()=>{
					this.$Progress.finish();
				});
		},

		remove: function() {
			const c = confirm('Delete selected?');
			if (!c) return;

			this.$Progress.start();
			this.$axios.delete(`/item`, {
				params: {
					batch: this.$route.params.ids.split(','),
				},
			})
				.then((response) => {
					this.$notify({
						group: 'main',
						title: 'Done.',
						text: 'The item has been removed.',
						type: 'success',
					});
          global_emits.$emit('item_deleted', {ids: this.$route.params.ids });
					this.$router.push({path: '/items'});
				})
				.catch((error) => {
					this.$notify({
						group: 'main',
						title: 'Something went wrong.',
						text: 'Please try again.',
						type: 'warn',
					});
				})
				.finally(()=>{
					this.$Progress.finish();
				});
		},
	},
	mounted: function() {
		// group by g1,g2...
		this.fieldmap = _.groupBy(this.fields, 'group');
		// sortby g number
		this.fieldmap = _(this.fieldmap).toPairs().sortBy(0).fromPairs().value();

		if ( this.$route.params.ids == undefined ) return;

		this.$Progress.start();
		this.$axios.get(`/item/batch`, {
			params: {
				batch: this.$route.params.ids.split(','),
			},
		})
			.then((response) => {
				this.item = response.data;
			})
			.catch((error) => {
				console.log(error);
			})
			.finally(()=>{
				this.$Progress.finish();
			});
	},

};
</script>

<style scoped lang="less">
  .item-edit{
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 5;
    top: 0;
    padding: 30px;

    .overlay{
      position: absolute;
      width: 100%;
      height: 100%;
      top:0;
      left: 0;
      background: rgba(0,0,0,0.5);
    }
    .content{
      background: #fff;
      height: 100%;
      overflow-y: scroll;
    }
  }

  .col-6{
    position: static;
  }
</style>
